module.exports = __webpack_public_path__ + "media/images/e-bilet/Hero_Tickets-4311f2ed84a7a397b00edea2b63fc9f8.png";